import script from "./VTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VTable.vue?vue&type=script&setup=true&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=9bc48faa&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bc48faa"]])

export default __exports__